import {
  Button,
  ModalContainer,
  ModalLayoutCenter,
  Text,
} from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import { MODAL_ID } from "./constants";

export interface CloseLeadModalProps {
  onCloseLead: () => void;
}

const CloseLeadModal: FunctionComponent<CloseLeadModalProps> = function ({
  onCloseLead,
}) {
  return (
    <ModalContainer id={MODAL_ID} opacity={30}>
      {({ handleClose }) => (
        <ModalLayoutCenter
          id="staff-revert-job-modal"
          onClose={() => {
            handleClose();
          }}
          className="w-100"
        >
          <Text text="Are you sure you want to close this lead?" />
          <div className="flex flex-row items-center justify-between mt-8">
            <Button.Text
              id="staff-close-lead"
              label="No"
              variant="danger"
              onClick={() => {
                handleClose();
              }}
            />
            <Button.Text
              id="staff-close-lead"
              label="Yes, close lead"
              onClick={() => {
                onCloseLead();
              }}
            />
          </div>
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default CloseLeadModal;
